<template>
    <div class="bg_fff">
        <!--搜索按钮-->
        <div class="header-search-wrap flex jcc aic">
            <input
                    type="search"
                    class="header-search-input fs12 pl20"
                    @blur="isFocus=false"
                    v-focus="isFocus"
            >
            <button class="header-search-btn">搜索</button>
        </div>
    </div>

</template>

<script>
  export default {
    name: "education-search-form",
    props: {
      // value: {
      //   type: Object,
      //   default: () => {
      //     return {}
      //   }
      // },
    },
    data() {
      return {
        form: {}
      }
    },
  }
</script>

<style scoped>
    .header-search-wrap{
        width: 100%;
        height: 100px;
        background: url("../../assets/icon/education/header-logo.png") no-repeat;
        background-position: 18px center;
        background-color: #ffffff;
    }
    .header-search-input{
        width: 260px;
        height: 34px;
        border: 1px solid #3692F9;
        border-radius: 17px 0 0 17px;
        outline: none;
    }
    .header-search-btn{
        width: 70px;
        height: 34px;
        border: 1px solid #3692F9;
        border-radius: 0 17px 17px 0;
        background-color: #3692F9;
        color: #ffffff;
        outline: none;
        cursor: pointer;
    }

</style>
